import ImagemCarregando from "../../ImagemCarregando";
import { useState } from "react";
import { createPortal } from "react-dom";
import plantio_image from "../../../../assets/plantio.png";
import { Card } from "./styled";
import ModalSolicitarPatrocinio from "../../ModalSolicitarPatrocinio";
import { linkValido } from "../../../../utils/links";

/**
 * Cartão de patrocinador. Com `patrocinador`, é o banner (clicável quando tem link
 * http/https). Sem ele, é o convite "Sua empresa aqui": o botão abre o PEDIDO de
 * patrocínio, que chega ao painel do administrador (antes abria um link de formulário
 * externo que o painel não edita mais).
 */
function CardApoiador({ patrocinador }) {
  const [pedindo, setPedindo] = useState(false);

  const imagem = (
    <ImagemCarregando src={patrocinador?.foto?.path ?? plantio_image} alt={patrocinador ? `Banner de ${patrocinador.nome}` : "Imagem do patrocinador"}
      className={patrocinador ? '' : 'img-patrocinador'} />
  );

  // Só vira link se houver um endereço http/https de verdade. Antes o convite
  // "Sua empresa aqui" embrulhava a imagem num <a href="https://undefined">.
  const link = patrocinador?.link ? (linkValido(patrocinador.link) ? patrocinador.link : `https://${patrocinador.link.replace(/^https?:\/\//i, '')}`) : null;

  return (
    <Card>
      {link && linkValido(link)
        ? <a href={link} target="_blank" rel="noopener noreferrer">{imagem}</a>
        : imagem}
      {!patrocinador &&
        <div className="info">
          <div className="tag">
            Patrocinador
          </div>
          <div className="title">
            Sua empresa aqui
          </div>
          <div className="details">
            Se torne um patrocinador do projeto e anuncie sua empresa para todos os plantadores do Brasil.
          </div>
          <div>
            <button type="button" className="quero" onClick={() => setPedindo(true)}>Quero ser um patrocinador</button>
          </div>
        </div>
      }
      {/* No body: os estilos do cartão (todo <a> com altura 100%) não podem alcançar o modal. */}
      {pedindo && createPortal(<ModalSolicitarPatrocinio onClose={() => setPedindo(false)} />, document.body)}
    </Card>
  );
}

export default CardApoiador;
